export default "__VITE_ASSET__CmDsO0y0__"